// red theme
export const clientThemeRed = {
    mainLayout: {
        backgroundColor: '#fafaf9',
        hover: {
            backgroundColor: '#00AAB4',
        },
    },
    topBar: {
        backgroundColor: '',
        contrastText: '',
        contrastLinkText: '#00AAB4',
        userIcon: '#B90000',
        brandLogo: {
            maxWidth: '200px',
            paddingTop: '0px',
        },
        menuBarIcon: {
            color: '#afafaf',
        },
    },
    sidebar: {
        fontSize: '14px',
        backgroundColor: '#121315',
        darkBackgroundColor: '#27272a',
        sideMenuActive: {
            backgroundColor: '#B90000',
            contrastText: '',
        },
        sideMenuHover: {
            backgroundColor: '#B90000',
            contrastText: '',
        },
    },
    footer: {
        backgroundColor: '',
        contrastText: '',
    },
    charts: {
        fill: '#EF9A9A',
        stroke: '#B90000',
        lineCharts: {
            stroke: '#B90000',
            fill: '#B90000',
        },
        areaCharts: {
            gradient: {
                start: '#B90000',
                stop: '#EF9A9A',
            },
            stroke: '#B90000',
            fill: '#ef9a9a',
            chargebacksByPostDateChart: {
                stroke: '#B90000',
                fill: '#EF9A9A',
            },
            newAlertsByDateChart: [
                {
                    stroke: '#B90000',
                    fill: '#B90000',
                },
                {
                    stroke: '#3C4146',
                    fill: '#3C4146',
                },
                {
                    stroke: '#FFC300',
                    fill: '#FFC300',
                },
                {
                    stroke: '#00AAB4',
                    fill: '#00AAB4',
                },
                {
                    stroke: '#8C9096',
                    fill: '#8C9096',
                },
            ],
        },
        barCharts: {
            fill: '#B90000',
            byPlatformBarChart: { fill: '#B90000' },
            byBinBarChart: { fill: '#B90000' },
            ertsByRevenueChart: {
                bar1Fill: '#EF9A9A',
                bar2Fill: '#B90000',
            },
            averageTimetoFileDispute: { fill: '#00AAB4' },
        },
        lineBarCharts: {
            byNonUniqueCustomerLineBarChart: {
                barColor: 'rgb(54, 119, 176)',
                lineColor: '#B90000',
            },
        },
        pieCharts: {
            defaultPieChart: [
                '#B90000',
                '#3C4146',
                '#FFC300',
                '#00AAB4',
                '#8C9096',
            ],
        },
        radialBarCharts: {
            fill: '#B90000',
        },
    },
    lockAndUnlockButton: {
        lockButton: {},
        unlockButton: {},
    },
    lampColors: {
        green: '#57a537',
        red: '#cb2022',
        orange: '#d87707',
        yellow: '#d8d800',
        grey: 'grey',
    },
    uploadDnD: {
        borderColor: `#cb2022`,
        backgroundColor: `rgba(203,32,34,.1)`,
        labelColor: `#cb2022`,
    },
    metricTile: {
        arrow: {
            width: 28,
            height: 28,
        },
    },
    caseBuilder: {
        color: '#B90000',
        saveAndContinueBtn: {
            margin: '0px',
            fontWeight: 700,
            textTransform: 'capitalize',
            backgroundColor: '#B90000',

            '&:hover': {
                backgroundColor: '#B90000',
            },
        },
        submittingColor: '#3cb4e5',
    },
    accentAreaTopBorderAccent: {
        backgroundColor: '',
        borderRadius: '',
    },
    dateRangeContainer: {
        borderRadius: '',
        padding: '7px 8px',
    },
    selectionBox: {
        borderRadius: '4px',
    },
    formFields: {
        formLabel: {},
        formText: {
            standard: {
                color: '#263238',
            },
            outlined: {
                fontSize: '',
            },
        },
    },
    labelTags: {
        borderRadius: '16px',
        backgroundColor: '#e0e0e0',
    },
    searchBar: {
        padding: '6px',
    },
    buttons: {
        styleButton: {
            root: {
                textTransform: 'capitalize',
            },
            contained: {
                textTransform: 'capitalize',
            },
        },
        defaultButton: {
            variant: 'contained',
            style: {
                backgroundColor: '#E0E0E0',
                color: 'rgba(0, 0, 0, 0.87)',
                '&:hover': {
                    backgroundColor: '#d5d5d5',
                },
            },
        },
         textOrOutlinedButton: {
            variant: 'outlined',
            style: {
                border: '1px solid #DDE2EB !important',
                borderRadius: '4px !important',
                color: '#263238',
                fontWeight: 600,
                padding: '4px 10px',
                fontSize: '14px',
                '&:hover': {
                    backgroundColor: 'rgba(38, 50, 56, 0.04)',
                },
            },
        },
        greyButton: {
            variant: 'contained',
            style: {
                color: '#4f4f4f',
                backgroundColor: '#D5D5D5',
                '&:hover': {
                    color: '#4f4f4f',
                    backgroundColor: '#D5D5D5',
                },
            },
        },
        greenButton: {
            variant: 'contained',
            style: {
                backgroundColor: '#3ED4AF',
                '&:hover': {
                    backgroundColor: '#3ac5a2',
                },
            },
        },
        activeStateButton: {
            color: 'white',
            backgroundColor: '#61656E',
        },
    },
    icons: {
        uploadIcon: '#00AAB4',
        dnrAndRevertDnrIcon: '#00AAB4',
        toggleUnlockIcon: '#75797b',
        toggleLockIcon: '#c80000',
        editUserIcon: '#2a7ea0',
        midPermissionIcon: '#714eb1',
        sitePermissionIcon: '#f88d2b',
        tempPasswordIcon: '#3cb4e5',
    },
    main: '#B90000',
    primaryLight: '#B90000',
    primary: '#B90000',
    primaryDark: '#B90000',
    secondaryLight: '#00AAB4',
    secondary: '#00AAB4',
    secondaryDark: '#00AAB4',
    hyperlink: '#00AAB4',
    textField: '#B90000',
    switch: '#B90000',
    typography: {
        fontColor: {
            primaryText: '',
            secondaryText: '',
        },
        fontFamily: ['Roboto'],
        fontFamilyConfig: {
            primary: 'Roboto',
            fallback: 'sans-serif',
        },
        h1: {
            fontSize: '35px',
        },
        h2: {
            fontSize: '29px',
        },
        h3: {
            fontSize: '24px',
        },
        h4: {
            fontSize: '20px',
        },
        h5: {
            fontSize: '16px',
        },
        h6: {
            fontSize: '14px',
        },
        subtitle1: {
            fontSize: '16px',
        },
        subtitle2: {
            fontSize: '14px',
        },
        subtitle3: {
            fontSize: '15px',
        },
        subtitle4: {
            fontSize: '14px',
        },
        body1: {
            fontSize: '14px',
        },
        body2: {
            fontSize: '12px',
        },
        button1: {
            fontSize: '14px',
        },
        button2: {
            fontSize: '13px',
        },
        caption: {
            fontSize: '11px',
        },
        overline: {
            fontSize: '11px',
        },
        label: {
            fontSize: '14px',
        },
        dataGrid: {
            tableHeader: {
                fontSize: '12.8px',
            },
            tableBody: {
                fontSize: '14px',
                color: '#52525b',
            },
            tableExpandable: {
                fontSize: '14px',
            },
        },
    },
}
